var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnlarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1538 24H17.5385V22.1538H21.1385L14.7692 16.6154L15.6923 14.7692L22.1538 20.4V17.5385H24V22.1538C23.9985 22.643 23.8036 23.1118 23.4577 23.4577C23.1118 23.8036 22.643 23.9985 22.1538 24ZM22.1538 3.59999L15.6923 9.23077L14.7692 7.38462L21.1385 1.84615H17.5385V0H22.1538C22.643 0.00146098 23.1118 0.19644 23.4577 0.542344C23.8036 0.888249 23.9985 1.35697 24 1.84615V6.46154H22.1538V3.59999ZM6.46154 22.1538V24H1.84615C1.35697 23.9985 0.888246 23.8036 0.542341 23.4577C0.196436 23.1118 0.00146098 22.643 0 22.1538V17.5385H1.84615V20.4L8.30769 14.7692L9.23077 16.6154L2.86154 22.1538H6.46154ZM8.30769 9.23077L1.84615 3.59999V6.46154H0V1.84615C0.00146098 1.35697 0.196436 0.888249 0.542341 0.542344C0.888246 0.19644 1.35697 0.00146098 1.84615 0H6.46154V1.84615H2.86154L9.23077 7.38462L8.30769 9.23077Z",
    fill: "#6C757D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnlarge);
export default __webpack_public_path__ + "static/media/enlarge.baede92d66adf68d47fb01bbe17a7554.svg";
export { ForwardRef as ReactComponent };